
import { Box, Button, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import dice_01 from "assets/icons/dice_01.svg";
import dice_02 from "assets/icons/dice_02.svg";
import dice_03 from "assets/icons/dice_03.svg";
import dice_04 from "assets/icons/dice_04.svg";
import dice_05 from "assets/icons/dice_05.svg";
import dice_06 from "assets/icons/dice_06.svg";
import { Typography } from "components/ui";
import React from "react";

const GamePaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: 24,
    textAlign: "center",
    boxShadow: theme.shadows[2],
    backgroundColor: "white",
    width: "100%",
    border: "1px solid #e0e0e0",
}));

const getDiceIcon = (num) => {
    const icons = {
        1: dice_01,
        2: dice_02,
        3: dice_03,
        4: dice_04,
        5: dice_05,
        6: dice_06,
    };
    return icons[num];
};

const DiceDisplay = ({
    myNumbers,
    isRolling,
    hasRolled,
    handleRollDice,
    setAllPlayersData,
}) => {
    return (
        <GamePaper sx={{ mb: 3, border: "3px solid #ffae00ff" }}>
            <Box
                sx={{
                    display: "grid",
                    justifyContent: "center",
                    gap: 2,
                    mb: 3,
                    gridTemplateColumns: "repeat(auto-fit, minmax(80px, max-content))",
                    justifyItems: "center",
                }}
            >
                {myNumbers.length > 0 ? (
                    myNumbers.map((num, i) => (
                        <Box
                            key={i}
                            sx={{
                                width: { xs: 70, sm: 90 },
                                height: { xs: 70, sm: 90 },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "16px",
                                boxShadow: "inset 0 0 8px rgba(0,0,0,0.05)",
                            }}
                        >
                            <Box
                                component="img"
                                src={getDiceIcon(num)}
                                sx={{ width: "85%" }}
                            />
                        </Box>
                    ))
                ) : (
                    <Box sx={{ py: 4, width: "100%", gridColumn: "1/-1" }}>
                        <Typography color="textSecondary">
                            กดปุ่มด้านล่างเพื่อสุ่มเลข
                        </Typography>
                    </Box>
                )}
            </Box>

            <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={() => {
                    setAllPlayersData(null);
                    handleRollDice();
                }}
                disabled={hasRolled || isRolling}
                sx={{ borderRadius: 2, py: 1.5 }}
            >
                {isRolling ? "Rolling..." : "🎲 ROLL DICE"}
            </Button>
        </GamePaper>
    );
};

export { getDiceIcon }; // Export for other components
export default DiceDisplay;
